<template>
  <div>
    <app-board bodyClass="p-3">
      <template slot="leftContent">
        <h5 class="border-bottom p-3">Testing Panel Setting / Profile Default Setting</h5>
      </template>
      <panelSettingForm :editMode="false" :onCreateCallback="addNewDefaultSetting"></panelSettingForm>
    </app-board>

    <div class="mt-5" v-if="defaultProfileSettings.length > 0 && fusionList.length">
      <app-board :header="false" class="p-3 mt-3 mb-5" v-for="(setting, index) in defaultProfileSettings" :key="index">
        <panelSettingForm :dataToBind="setting" :bindingForView="true"  :recordId="setting.id" :editMode="true" :setting="setting" :key="index"></panelSettingForm>
      </app-board>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
export default {
  components: {
    panelSettingForm: () => import('./../form/View.vue')
  },
  data () {
    return {
      defaultProfileSettings: []
    }
  },
  computed: {
    ...mapState('voip-testing-panel-setting-state', ['fusionList']),
  },
  beforeMount() {
    this.getDefaultProfilesSetting().then( (r) => {
      this.defaultProfileSettings = r.data
    })
  },
  methods: {
    ...mapActions('voip-testing-panel-default-setting-api', { getDefaultProfilesSetting: 'getDefaultProfilesSetting'}),
    addNewDefaultSetting (setting) {
      this.defaultProfileSettings.push(setting)
    }
  }
}
</script>
